module.exports = __webpack_public_path__ + "static/media/preview-banner.0c08c3be.png";